module.exports = __webpack_public_path__ + "static/media/DrWeber.95c07da9.jpg";